import { Trans } from '../localization/Translation.js'
import Wrapper from '../components/Wrapper.vue'
import BlogHelper from '../helpers/blogHelper.js'

function load(component) {
  return () => import(/* webpackChunkName: "[request]" */ `../pages/${component}.vue`)
}

export default [
  {
    path: '/:lang',
    component: Wrapper,
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: '',
        name: 'Home',
        component: load('Home'),
        meta: {
          supportedLanguages: ['en', 'es', 'ca'],
          localizedTitleKey: "pages.home",
          isMenu: false,
          order: -1,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: 'about',
        name: 'About',
        component: load('About'),
        meta: {
          supportedLanguages: ['en', 'es', 'ca'],
          localizedTitleKey: "pages.about",
          isMenu: true,
          order: 0,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: 'blog',
        name: 'Blog',
        component: load('Blog'),
        meta: {
          supportedLanguages: ['en', 'es'],
          localizedTitleKey: "pages.blog",
          isMenu: true,
          order: 3,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: 'work/:company',
        name: 'CompanyDetail',
        component: load('CompanyDetail'),
        meta: {
          supportedLanguages: ["en", "es"],
          isMenu: false,
          order: -1,
          isWrapped: false,
          hasLanguages: true
        }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: load('Contact'),
        meta: {
          supportedLanguages: ['en', 'es', 'ca'],
          localizedTitleKey: "pages.contact",
          isMenu: true,
          order: 4,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: ':year/:month/:day/:title',
        name: 'Entry',
        component: load('Entry'),
        meta: {
          supportedLanguages: ["en", "es"],
          isMenu: false,
          order: -1,
          isWrapped: false,
          hasLanguages: false
        },
        beforeEnter: BlogHelper.getBlogPOST,
        props: {
          entry: null
        }
      },
      {
        path: 'work',
        name: 'Work',
        component: load('Work'),
        meta: {
          supportedLanguages: ['en', 'es'],
          localizedTitleKey: "pages.work",
          isMenu: true,
          order: 1,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: 'kumpor',
        name: 'Kumpor',
        component: load('Kumpor'),
        meta: {
          supportedLanguages: ['en', 'es', 'ca'],
          localizedTitleKey: "pages.kumpor",
          isMenu: true,
          order: 6,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: 'skills',
        name: 'Skills',
        component: load('Skills'),
        meta: {
          supportedLanguages: ['en', 'es', 'ca'],
          localizedTitleKey: "pages.skills",
          isMenu: true,
          order: 2,
          isWrapped: true,
          hasLanguages: true
        }
      },
      {
        path: '*',
        component: load('404'),
      }
    ]
  },
  {
    // Redirect user to supported lang version.
    path: '*',
    // eslint-disable-next-line no-unused-vars
    redirect(to) {
      return Trans.getUserSupportedLang()
    }
  },
]